export const PHONE_DISPLAY = "+1 702-485-5930";
export const PHONE_TEL = "tel:+17024855930";
export const EMAIL = "carlitoscubanfood.shop@gmail.com";
export const ADDRESS = "2680 S Maryland Pkwy B, Las Vegas, NV 89109";
export const HOURS = "Todos los días: 7:00 a.m. – 9:00 p.m.";
export const CLOVER_ORDER_URL = "https://carlitos-cuban-food-las-vegas.cloveronline.com";
// Menú visible desde el 2026-10-19 (pedido de Kevin) — /menu ya se puede ver.
export const MENU_BROWSE_LOCKED = false;
// El carrito y el pago siguen apagados: la API de Clover (pago con tarjeta)
// todavía no tiene credenciales configuradas en el servidor. En cuanto estén
// listas y probadas, poner en false para habilitar "Ordenar" y el checkout.
export const MENU_LOCKED = true;
export const SITE_URL = "https://carlitoscubanfood.com";
export const DELIVERY_FEE = 4.99; // debe coincidir con DELIVERY_FEE en backend/server.py

export const IMG = {
  heroPlate: "https://images.pexels.com/photos/29450677/pexels-photo-29450677.jpeg?auto=compress&cs=tinysrgb&w=1200",
  heroFood: "https://images.pexels.com/photos/29205252/pexels-photo-29205252.jpeg?auto=compress&cs=tinysrgb&w=1200",
  step1: "https://images.unsplash.com/photo-1577219492769-b63a779fac28?auto=format&fit=crop&w=1600&q=80",
  step2: "https://images.pexels.com/photos/13343442/pexels-photo-13343442.jpeg?auto=compress&cs=tinysrgb&w=1600",
  step3: "https://images.unsplash.com/photo-1699728088621-38d201c24ac3?auto=format&fit=crop&w=1600&q=80",
  vegas: "https://images.unsplash.com/photo-1587223043646-fa771d9e0c8b?auto=format&fit=crop&w=1200&q=80",
  community: "https://images.pexels.com/photos/11186008/pexels-photo-11186008.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
